<template>
  <div class="nearPayorder">
    <section class="main_section">
      <div class="near_pay">
        <div class="order_details">
          <ul class="payorderInfo">
            <li class="order_status">
              <span>Total amount to be paid :</span>
              <span class="text-value">₹ {{nearPayDetail.totalPaidAmount}}</span>
            </li>

            <li class="order_status">
              <span>Token Number :</span>
              <span class="text-value">{{nearPayDetail.token}}</span>
            </li>
          </ul>
          <ul class="payordersteps">
            <li class="order_step b_border">
              <div class="icon">
                <img src="../../assets/images/nearPay_location.jpeg" alt />
              </div>
              <div class="text">
                <p>अपने नज़दीकी एजेंट के पास जाए</p>
                <span>नीचे दिए बटन पे क्लिक करके नज़दीकी एजेंट्स की लिस्ट देखे</span>
              </div>
            </li>
            <li class="order_step b_border">
              <div class="icon">
                <img src="../../assets/images/share_token.jpeg" alt />
              </div>
              <div class="text">
                <p>एजेंट से अपना टोकेन नम्बर शेएर करे</p>
                <span>टोकेन नम्बर आप ऊपर से ले सकते है। टोकेन नम्बर आपको मेसेज पे भी भेजा जाएगा।</span>
              </div>
            </li>
            <li class="order_step">
              <div class="icon">
                <img src="../../assets/images/token_number.jpeg" alt />
              </div>
              <div class="text">
                <p>एजेंट के पास कैश में भुगतान करे</p>
                <span>भुगतान करते ही आपका पेमेंट मंज़ूर हो जाएगा।</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="find_agent_section">
          <p>To settle payment</p>
          <h2>Find NearPe agents near you below</h2>
          <button type="button" class="find_btn" @click="gotoNearPe()">Find Agents</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ImageSpinner from "../Common/ImageSpinner";
import store from "../../store/store";
export default {
  name: "NearPayOrderDetails",
  components: {
    ImageSpinner,
  },
  props: {},
  data() {
    return {
      nearPayDetail : {}
    };
  },
  watch: {},
  methods: {
    gotoNearPe(){
      window.location.href = this.nearPayDetail.storeLink
    },
    getOrderByPreOrder(){     
      this.loading = true;
      this.$store
        .dispatch({
          type: "orderById",
          payload: this.$route.params.orderId
        })
        .then(data => {
          this.nearPayDetail = data.data;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.getOrderByPreOrder()
  }
};
</script>

<style>
</style>